import { useEffect } from "react";
import { useSelector } from "react-redux";
import { setGlobalTextSize, useGlobalState } from "senf-shared";
import { useGetTranslations } from "senf-shared/utils/hooks";
import i18n from "senf-shared/utils/i18n";

const useAccessibility = () => {
  const project = useSelector((state) => state.data.project);
  const [accessibility, setAccessibility] = useGlobalState().accessibilityState;
  const [translation, setTranslation] = useGlobalState().translationsState;
  const { fetchTranslations } = useGetTranslations(project);

  const initializeAccessibility = async () => {
    if (
      localStorage.getItem("accessibility") &&
      project?.settings?.accessibility
    ) {
      setAccessibility(true);
    }
  };

  useEffect(() => {
    if (accessibility && project?.settings?.accessibility) {
      setGlobalTextSize("large");
      if (project?.settings?.originalLanguage === i18n.resolvedLanguage) {
        fetchTranslations("de-simple");
      } else {
        fetchTranslations(i18n.resolvedLanguage);
      }
    } else {
      setTranslation(null);
      fetchTranslations(i18n.resolvedLanguage);
      setGlobalTextSize("medium");
    }
  }, [accessibility]);

  useEffect(() => {
    if (project?.projectId) {
      initializeAccessibility();
    }
  }, [project?.projectId]);
};

export default useAccessibility;
